import * as React from "react";

interface Props extends React.SVGProps<SVGSVGElement> {
    size?: number;
}

const XIcon = ({ size = 15, ...props }: Props) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle
            cx="8"
            cy="8"
            r="7"
            stroke={props.color || "currentColor"}
            strokeWidth="1.25"
        />
        <path
            d="M5.5 5.5L10.5 10.5M10.5 5.5L5.5 10.5"
            stroke={props.color || "currentColor"}
            strokeWidth="1.25"
            strokeLinecap="round"
        />
    </svg>
);

export default XIcon;
